<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home/Home' }">主页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">不良品项统计</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="110px" size="small">
        <!-- <el-row>
          <el-col :span="6" v-if="'orderCode' in colObj2">
            <el-form-item label="工单编号">
              <el-input size="small" v-model="form.orderCode" placeholder="工单编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'productCode' in colObj2">
            <el-form-item label="产品编号">
              <el-input size="small" v-model="form.productCode" placeholder="产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'productName' in colObj2">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'specs' in colObj2">
            <el-form-item label="产品规格">
              <el-input size="small" v-model="form.specs" placeholder="产品规格" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" v-if="'processCode' in colObj2">
            <el-form-item label="工序编号">
              <el-input size="small" v-model="form.processCode" placeholder="工序编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"  v-if="'processName' in colObj2">
            <el-form-item label="工序名称">
              <el-input size="small" v-model="form.processName" placeholder="工序名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'name' in colObj2">
            <el-form-item label="生产人员">
              <el-input size="small" v-model="form.name" placeholder="生产人员" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'createTime' in colObj2">
            <el-form-item label="报工时间">
              <el-date-picker
                v-model="form.createTime"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'produceTime' in colObj2">

              <el-form-item label="生产时间">
                <el-date-picker
                  key="0"
                  class="half-width"
                  v-model="form.produceTime"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'nongoodName' in colObj2">
            <el-form-item label="不良品项">
              <el-input size="small" v-model="form.nongoodName" placeholder="不良品项" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'nongoodName' in colObj2">
            <el-form-item label="占比">
              <el-input size="small" v-model="form.nongoodName" placeholder="不良品项" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" v-if="'countNum' in colObj2">
            <el-form-item label="报工数">
              <el-input-number
                size="small"
                v-model="form.countNum"
                placeholder="报工数"
                controls-position="right"
                :min="0"
                clearable
                style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="'nongoodNum' in colObj2">
            <el-form-item label="不良品数">
              <el-input-number
                size="small"
                v-model="form.nongoodNum"
                placeholder="不良品数"
                controls-position="right"
                :min="0"
                clearable
                style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'nongoodRate' in colObj2">
            <el-form-item label="不良品率">
              <el-input-number
                size="small"
                v-model="form.nongoodRate"
                placeholder="不良品率"
                controls-position="right"
                :min="0"
                clearable
                style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>

        </el-row> -->
        <el-row>
          <el-col :span="6" v-if="'produceTime' in colObj2">

            <el-form-item label="生产时间">
              <el-date-picker
                style="width: 100%;"
                v-model="form.produceTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'nongoodName' in colObj2">
            <el-form-item label="不良品项">
              <el-input size="small" v-model="form.nongoodName" placeholder="不良品项" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="'rate' in colObj2">
            <el-form-item label="占比">
              <el-input size="small" v-model="form.rate" placeholder="占比" clearable style="width:calc(100% - 15px)"></el-input>%
            </el-form-item>
          </el-col>
          <el-col :span="6" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <!-- <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow2"
            >
              <PopoverContentNew :colData="colData2" @done="popDone2" v-if="popIshow2" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">关键词配置</el-button>
            </el-popover> -->
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>
          </el-col>
          <!-- <el-col :span="12" style="text-align: right;">
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <PopoverContentNew :colData="colData" @done="popDone" v-if="popIshow" ></PopoverContentNew>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">列配置</el-button>
            </el-popover>
          </el-col> -->
        </el-row>
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" :reserve-selection="true" width="60" fixed="left"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号" fixed="left"></el-table-column>

          <!-- <el-table-column prop="orderCode" label="工单编号" min-width="120" v-if="'orderCode' in colObj"></el-table-column>
          <el-table-column prop="productCode" label="产品编号" min-width="100" v-if="'productCode' in colObj"></el-table-column>

          <el-table-column prop="productName" label="产品名称"  v-if="'productName' in colObj"></el-table-column>
          <el-table-column prop="specs" label="产品规格" v-if="'specs' in colObj"></el-table-column>
          <el-table-column prop="processCode" label="工序编号" v-if="'processCode' in colObj"></el-table-column>
          <el-table-column prop="processName" label="工序名称" v-if="'processName' in colObj"></el-table-column>
          <el-table-column prop="name" label="生产人员" min-width="100" v-if="'name' in colObj"></el-table-column>
          <el-table-column prop="createTime" label="报工时间" width="140" v-if="'createTime' in colObj"></el-table-column>
          <el-table-column prop="nongoodName" label="不良品项" v-if="'nongoodName' in colObj"></el-table-column> -->
          <el-table-column prop="nongoodName" label="不良品项" fixed="left"></el-table-column>
          <el-table-column prop="rate" label="占比" fixed="left">
            <template slot-scope="scope">
              <span>{{scope.row.rate + '%'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nongoodName" label="合计" fixed="left">
            <template slot-scope="scope">
              <span>{{scope.row.totalNonGoodNum}}</span>
            </template>
          </el-table-column>
          <el-table-column v-for="item in setList" :key="item" :prop="item" :label="item"></el-table-column>

          <!-- <el-table-column prop="countNum" label="报工数" v-if="'countNum' in colObj"></el-table-column>
          <el-table-column prop="nongoodNum" label="不良品数" v-if="'nongoodNum' in colObj"></el-table-column>
          <el-table-column prop="nongoodRate" label="不良品率" v-if="'nongoodRate' in colObj">
            <template slot-scope="scope">
              <span class="txt-overflow">{{scope.row.nongoodRate?scope.row.nongoodRate.toFixed(2):""}}</span>
            </template>
          </el-table-column> -->

        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination> -->
      </div>
      </div>

  </div>
</template>
<script>

import {nonGoodReport} from '@/api/business';
import Pagination from "@/components/Pagination";
import moment from 'moment';
import PopoverContentNew from '@/components/PopoverContentNew'
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "NoGoodDistributionMonth",
  components:{
      Pagination,
      PopoverContentNew
  },
  data() {
    return {
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "0"
        },
        {
          label: "外购",
          value: "1"
        },
        {
          label: "委外",
          value: "2"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,
      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      setList:[],
      popIshow:false,//控制popover显隐
      colData:[],
      colDataRes:{
        // "工单编号":"orderCode",
        // "产品编号":"productCode",
        // "产品名称":"productName",
        // "产品规格":"specs",
        // "工序编号":"processCode",
        // "工序名称":"processName",
        // "生产人员":"name",
        // "报工时间":"createTime",
        // "报工数":"countNum",
        // "不良品数":"nongoodNum",
        // "不良品率":"nongoodRate",
        "生产时间":"produceTime",
        "不良品项":"nongoodName",
        "占比":"rate",
      },
      colObj:{},
      popIshow2:false,
      colData2:[],
      colObj2:{},
      tblSelectionList:[]

    };
  },
  created() {
    for(let key in this.colDataRes){
      this.colData.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj[this.colDataRes[key]] = key;
      this.colData2.push({label:this.colDataRes[key],value:key,istrue:true});
      this.colObj2[this.colDataRes[key]] = key;
    }
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();

    }
  },
  methods: {
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
       item.rate = item.rate + '%';
       item.total = item.totalNonGoodNum;
      });
      return data;
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        // this.exportExcel();
        this.$message.error('请选择要导出的数据！')
        return;
      }
      const header = [

        '不良品项',
        '占比',
        '合计',

      ];

      const filterVal = [
        'nongoodName',
        'rate',
        'total',
      ];
      for(let i = 0;i<this.setList.length;i++){
        header.push(this.setList[i]);
        filterVal.push(this.setList[i]);
      }
      let filterData =this.filterTableData( JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"不良品项统计"+ Date.now());
    },
    popDone:function(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data));
        this.colObj = {};
        for(let i = 0;i<this.colData.length;i++){
          if(this.colData[i].istrue){
            this.colObj[this.colData[i].label] = this.colObj[this.colData[i].value];
          }
        }
        this.init();
      }
    },
    popDone2:function(options){
      var _this = this
      this.popIshow2 = false
      if(options.type == 'save'){
        this.colData2 = JSON.parse(JSON.stringify(options.data));
        this.colObj2 = {};
        var _form = {};
        for(let i = 0;i<this.colData2.length;i++){
          if(this.colData2[i].istrue){
            this.colObj2[this.colData[i].label] = this.colObj2[this.colData2[i].value];
            _form[this.colData[i].label] = this.form[this.colData[i].label]
          }
        }
        this.form = JSON.parse(JSON.stringify(_form));
        this.init();
      }
    },
    init(){
      this.search();
    },
    fold() {
      this.isFold = !this.isFold;
    },
    search() {
      this.loading = true
      var data = {
        condition: {},
        // currentPage: this.pageparm.currentPage,
        // pageSize: this.pageparm.pageSize,
      }
      for(var key in this.form){

        if(this.form[key] && this.form[key] != null && (this.form[key].length > 0 || this.form[key].toString() != '')){
            if(key == "produceTime"){
              data['condition'][key] = {
                begin:this.form.produceTime[0].substring(0,10) + " 00:00:00",
                end:this.form.produceTime[1].substring(0,10) + " 23:59:59",
                type:"between" ,
                data:'date'
              }
            }else if(key != 'aprovalCondition'){

              data['condition'][key] = this.form[key];
            }
        }else{
          // if(key == "produceTime"){
          //   data['condition'][key] = {
          //     begin:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,8) + '01' + " 00:00:00",
          //     end:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,10) + " 23:59:59",
          //     type:"between" ,
          //     data:'date'
          //   }
          // }
        }
      }
      // if(!data['condition']['produceTime']){
      //   data['condition']['produceTime'] = {
      //     begin:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,8) + '01' + " 00:00:00",
      //     end:moment().format("YYYY-MM-DD HH:mm:ss").substring(0,10) + " 23:59:59",
      //     type:"between" ,
      //     data:'date'
      //   }
      // }
      data.condition.factoryId=this.userData.factoryId;
      nonGoodReport(data).then(res => {
        if(res.code == 200){
          this.listData = [];
          this.setList = [];
          this.pageparm = res.data;
          for(let i = 0;i<  res.data.length;i++){
            if(res.data[i]['detail']){

              for(let j = 0;j < res.data[i]['detail'].length;j++){
                if(this.setList.indexOf(res.data[i]['detail'][j]['produceTime']) > -1){
                  res.data[i][res.data[i]['detail'][j]['produceTime']] = res.data[i]['detail'][j]['nongoodNum'] ;
                }else{

                  this.setList.push(res.data[i]['detail'][j]['produceTime']);
                  res.data[i][res.data[i]['detail'][j]['produceTime']] = res.data[i]['detail'][j]['nongoodNum'] ;
                }
              }
            }
            this.listData.push(res.data[i]);
          }
          this.setList.sort();
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },



     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },
    exportExcel(){
      //this.loading = true
      var data = {
        condition: this.form,
        type:"不良品项统计",
        currentPage: 1,
        pageSize: 10000,
      }
      data.condition.factoryId=this.userData.factoryId;
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/report/export';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "不良品项统计" + moment().format("YYYYMMDDHHmmss") + ".xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(data));
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/home/report/NoGoodDistributionMonth.vue